import { font, oPopupBorderTop, oPopupPadding, Popup } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled(Popup.DefaultContent)`
    max-width: 95%;
    max-height: 95%;
    min-width: 640px;
    width: 900px;
    height: 650px;
`;

export const Content = styled.div`
    ${oPopupPadding}
    ${oPopupBorderTop};
    padding-top: 32px;
    overflow-y: auto;
    display: flex;
    flex-flow: column;
`;

export const Header = styled.div`
    text-transform: uppercase;
    margin-bottom: 18px;
    flex: none;
    ${font(18, '#333')}
`;

export const RowGroup = styled.div`
    display: flex;
    flex-flow: column;
    margin-bottom: 10px;
    flex: none;
`;

export const Row = styled.div`
    display: flex;
    margin-bottom: 10px;
    flex: none;

    & > * {
        flex: 1;
    }

    & > :not(:first-child) {
        margin-left: 10px;
    }

    & > :not(:last-child) {
        margin-right: 10px;
    }
`;
